import React from 'react';
import { ReactComponent as PoweredBySvg } from '../../assets/images/powered_by_next_order.svg';

const PoweredByComponent = () => {
  return (
    <div className='powered-by-container'>
      <PoweredBySvg height='15px' />
    </div>
  );
};

export default PoweredByComponent;
